module.exports = __webpack_public_path__ + "img/u17762.7d246847.svg";